import { Component, OnInit } from '@angular/core';
import { ObservableMedia } from '@angular/flex-layout';
import { environment } from 'src/environments/environment';
const packageJson = require('../../../package.json');

@Component({
  selector: 'esc-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(
    public media: ObservableMedia,
  ) { }

  public webtoolVersion = packageJson.version;
  private qaVersioning = '.0';

  ngOnInit() {
    if(!environment.production){
      this.webtoolVersion = this.webtoolVersion + this.qaVersioning;
    }
  }

}
